import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const focusedBorderStyle = {
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4AB3BC',
    },
  },
};

// 폼에 저장된 값(숫자 또는 콤마 문자열, 빈값 허용)을 화면용 콤마 문자열로 변환
const formatPriceForDisplay = rawValue => {
  if (rawValue === undefined || rawValue === null || rawValue === '') return '';
  const cleaned = String(rawValue).replace(/,/g, '');
  if (cleaned === '') return '';
  const num = Number(cleaned);
  if (Number.isNaN(num) || num < 0) return '';
  return new Intl.NumberFormat('en-US').format(num);
};

// 사용자가 입력한 문자열을 숫자(또는 빈 문자열)로 파싱. 유효하지 않으면 null 반환.
const parsePriceInput = rawInput => {
  const cleaned = rawInput.replace(/,/g, '');
  if (cleaned === '') return '';
  if (!/^[0-9]+$/.test(cleaned)) return null;
  return Number(cleaned);
};

export const FormInputPrice = ({
  name = '',
  control,
  rules,
  disabled,
  label,
  placeholder,
  type = 'text',
  size,
  sx,
  className,
  id,
  inputProps,
  InputProps,
  onChange,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange: formOnChange, value }, fieldState: { error } }) => {
        const handleChange = e => {
          const parsed = parsePriceInput(e.target.value);
          // 유효하지 않은 입력(숫자 외 문자 등)은 폼 값 갱신 자체를 차단
          if (parsed === null) return;
          formOnChange({ ...e, target: { ...e.target, value: parsed } });
          if (onChange) onChange(e);
        };

        return (
          <TextField
            id={id}
            name={name}
            value={formatPriceForDisplay(value)}
            type={type}
            disabled={disabled}
            label={label}
            placeholder={placeholder}
            error={!!error}
            helperText={error ? error.message : null}
            onChange={handleChange}
            size={size}
            fullWidth
            variant="outlined"
            className={className}
            inputProps={{ maxLength: 14, ...inputProps }}
            InputProps={InputProps}
            sx={{ ...focusedBorderStyle, ...sx }}
          />
        );
      }}
    />
  );
};
